<template>
  <div :class="classes">
    <ul ref="list" :class="wheelWrapperClass">
      <li :class="defaultOptionClass">{{ typeText }}</li>
      <li v-for="(item, index) in list" :key="index" :class="$_getItemClass(item, index)" role="button" @click="$_onClickSelect(item)">
        {{ item.value }}
      </li>
    </ul>
  </div>
</template>

<script>
import raf from 'raf'
import Bus from '@/utils/bus'
import locale from '@/mixins/locale'

import {
  PREFIX_CLASS
} from '@/utils/constants'

const PREFIXCLS = `${PREFIX_CLASS}time-picker__col`

const scrollTo = (element, to, duration) => {
  // jump to target if duration zero
  if (duration <= 0) {
    raf(() => {
      element.scrollTop = to
    })
    return
  }
  const difference = to - element.scrollTop
  const perTick = (difference / duration) * 10

  raf(() => {
    element.scrollTop += perTick
    if (element.scrollTop === to) return
    scrollTo(element, to, duration - 10)
  })
}

export default {
  name: 'TTimeCol',
  mixins: [ locale ],
  props: {
    list: {
      type: Array,
      default: () => []
    },
    value: {
      type: [Number, String],
      default: 0
    },
    type: {
      type: String,
      default: 'H'
    }
  },
  data () {
    return {
      prefixCls: PREFIXCLS
    }
  },
  computed: {
    classes () {
      return [`${this.prefixCls}`]
    },
    wheelWrapperClass () {
      return [`${this.prefixCls}__wheel`]
    },
    model: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    typeText () {
      return this.type === 'H' ? this.t('t.timePicker.hour') || '时' : this.type === 'm' ? this.t('t.timePicker.minute') || '分' : this.t('t.timePicker.second') || '秒'
    },
    defaultOptionClass () {
      return [`${this.prefixCls}-select-option-default`]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$_scrollToSelected(0)
    })
    Bus.$on('g-time-picker-visible', () => {
      this.$nextTick(() => {
        this.$_scrollToSelected(0)
      })
    })
  },
  updated() {
    this.$_scrollToSelected(120)
  },
  methods: {
    $_getItemClass (item, index) {
      return [
        {
          [`${this.prefixCls}-select-option-selected`]: Number(this.model) === Number(item.value),
          [`${this.prefixCls}-select-option-disabled`]: item.disabled
        }
      ]
    },
    $_scrollToSelected(duration) {
      // move to selected item
      const select = this.$el
      const list = this.$refs.list
      if (!list) {
        return
      }
      let index = this.list.findIndex((item) => Number(item.value) === Number(this.model))
      if (index < 0) {
        index = 0
      }
      const topOption = list.children[index]
      const to = topOption.offsetTop
      scrollTo(select, to, duration)
    },
    $_onClickSelect (item) {
      if (item.disabled) return
      this.$emit('on-select', this.type, item.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/time-picker/col.vue